export default {
  noMatchesFound: 'No overlap of signals found between source and target. No migration possible.',
};
